module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.content.section_2.video_link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.content.section_2.video_link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content.section_2.heading) ? _c('h3', {
    staticClass: "article__video-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.section_2.body) ? _c('p', {
    staticClass: "article__video-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  }) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa0742a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vision-mission/overview/overview.vue
// module id = 861
// module chunks = 0